export default {

  getUserIP() {
    return new Promise((resolve, reject) => {
      // 创建RTCPeerConnection接口
      const conn = new RTCPeerConnection({
        iceServers: []
      })
      const noop = () => {}
      conn.onicecandidate = (ice) => {
        if (ice.candidate) {
          // 使用正则获取ip
          const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
          let ipAddr = ''
          try {
            const exexRes = ipRegex.exec(ice.candidate.candidate) || []
            ipAddr = exexRes[1] || '127.0.0.1'
          } catch (error) {
            ipAddr = '127.0.0.1'
          }
          resolve(ipAddr)
          conn.onicecandidate = noop
        }
      }
      // 随便创建一个叫狗的通道(channel)
      conn.createDataChannel('dog')
      // 创建一个SDP协议请求
      // @ts-ignore
      conn.createOffer(conn.setLocalDescription.bind(conn), noop)
    })
  }
}
